<template>
  <section id="workflow-users-list">
    <el-tabs
      type="card"
      @tab-click="handleClick"
      v-model="activeTab"
      :style="getIsMobile ? 'margin-top:8px' : ''"
    >
      <el-tab-pane label="Need to be Approved" name="need_to_be_approved">
        <span slot="label">
          Need to be Approved
          <div class="count-circle" style="background-color: #007bff">
            {{ needToApproveCount }}
          </div>
        </span>
      </el-tab-pane>
      <el-tab-pane
        :label="approvalHoldName ? approvalHoldName : 'HOLD'"
        name="hold"
      >
        <span slot="label">
          {{ approvalHoldName ? approvalHoldName : "HOLD" }}
          <div class="count-circle" style="background-color: #f2dd27">
            {{ holdCount }}
          </div>
        </span>
      </el-tab-pane>
      <el-tab-pane label="Waiting for others" name="waiting_for_others">
        <span slot="label">
          Waiting for others
          <div class="count-circle" style="background-color: #e6a23c">
            {{ needToApproveOthersCount }}
          </div>
        </span>
      </el-tab-pane>
      <el-tab-pane label="Approved" name="approved">
        <span slot="label">
          Approved
          <div class="count-circle" style="background-color: #67c23a">
            {{ approvedCount }}
          </div>
        </span>
      </el-tab-pane>
      <el-tab-pane label="Rejected" name="rejected">
        <span slot="label">
          Rejected
          <div class="count-circle" style="background-color: #f56c6c">
            {{ rejectedCount }}
          </div>
        </span>
      </el-tab-pane>
    </el-tabs>
    <div class="container mb-4">
      <div v-if="selectedRowsIds.length > 0">
        <el-dropdown>
          <button
            class="btn btn-primary btn-sm m-lr-1 p-2 rounded"
            type="button"
          >
            <i class="fa fa-cogs"></i> Bulk Actions
          </button>
          <el-dropdown-menu slot="dropdown">
            <template>
              <a @click="approveAllChecked">
                <el-dropdown-item command="approve">
                  <i class="fa fa-check"></i> Approve
                </el-dropdown-item>
              </a>
              <a @click="holdAllChecked">
                <el-dropdown-item command="approve">
                  <i class="fa fa-hourglass-half"></i> {{ approvalHoldName }}
                </el-dropdown-item>
              </a>
              <a @click="showBulkRejectConfirm">
                <el-dropdown-item command="reject">
                  <i class="fa fa-times"></i> Reject
                </el-dropdown-item>
              </a>
            </template>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="filter-container">
        <div class="filter-icon-box">
          <i class="fa fa-filter"></i>
        </div>
        <el-select
          v-model="selectedFilterFormbuilderids"
          placeholder="Filter by Form Name"
          size="mini"
          multiple
          collapse-tags
          clearable
          @change="fetchAllEmployee"
        >
          <el-option
            v-for="item in allFormbuildersDetails"
            :key="item._id"
            :label="item.name"
            :value="item._id"
          >
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="inner-navbar-content top">
      <div class="vue-data-table-default approval-form">
        <el-table
          :data="data"
          :total="total"
          :resizable="true"
          border
          :current-page.sync="currentPage"
          :page-size="pageSize"
          :pagination-props="paginationProps"
          @query-change="loadData"
          v-loading="loading"
          element-loading-spinner="el-icon-loading"
          :element-loading-text="
            loadingText ? loadingText : 'Fetching approval data, please wait...'
          "
          v-if="!getIsMobile"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            width="55"
            v-if="
              activeTab !== 'approved' &&
              activeTab !== 'rejected' &&
              activeTab !== 'waiting_for_others'
            "
          >
          </el-table-column>
          <el-table-column fixed="left" min-width="170" label="Form Name">
            <template slot-scope="scope">
              <div
                v-if="
                  scope.row &&
                  scope.row.formbuilders_details_id &&
                  scope.row.formbuilders_details_id.name
                "
                style="
                  word-break: break-word;
                  padding-top: 12px;
                  padding-bottom: 12px;
                "
              >
                {{
                  scope.row.formbuilders_details_id.name | truncate(20, "...")
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="User name" min-width="180">
            <template slot-scope="scope">
              <div class="d-flex" v-if="!isAnonymousForm(scope.row)">
                <div style="word-break: break-word">
                  {{ getUserName(scope.row) }}
                </div>
              </div>
              <div v-else>
                <el-popover
                  placement="top-start"
                  title="User info"
                  width="300"
                  trigger="hover"
                  v-if="
                    scope.row &&
                    scope.row.formbuilders_details_id &&
                    scope.row.formbuilders_details_id.primary_fields
                  "
                >
                  <div slot="reference">
                    <i class="el-icon-info"></i>
                    <span class="d-inline-block pl-10"> ANONYMOUS </span>
                  </div>
                  <div>
                    <div
                      v-for="op in scope.row.formbuilders_details_id
                        .primary_fields"
                      :key="op + '_key'"
                    >
                      {{ getFormbuilderFieldValue(op, scope.row) }}
                    </div>
                  </div>
                </el-popover>
                <div v-else>ANONYMOUS</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="User email / User IP Address" min-width="250">
            <template slot-scope="scope">
              <div class="d-flex" v-if="!isAnonymousForm(scope.row)">
                <div>{{ getUserEmail(scope.row) }}</div>
              </div>
              <div v-else>
                <div>{{ scope.row.ip_address }}</div>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            v-if="hasIntervals"
            label="Submitted For"
            min-width="150"
          >
            <template slot-scope="scope">
              <div>
                <span class="black-coral sm-80" v-if="scope.row.time_interval">
                  {{
                    scope.row.time_interval
                      | moment(fequencyDateMap[intervalType])
                  }}
                </span>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="Approval Status" min-width="180">
            <template slot-scope="scope">
              <div
                class="success"
                v-if="scope.row.approval_status == 'APPROVED'"
              >
                <el-popover
                  placement="top-start"
                  title="Approval details:"
                  width="300"
                  trigger="hover"
                >
                  <div v-if="scope.row.priority_based">
                    <span
                      v-if="
                        getApprovedUser(scope.row) &&
                        getApprovedUser(scope.row).approved_by
                      "
                      >Approved by: {{ getApprovedUser(scope.row).approved_by }}
                    </span>
                    <br />
                    <span
                      v-if="
                        getApprovedUser(scope.row) &&
                        getApprovedUser(scope.row).approved_at
                      "
                      >Approved on:
                      {{
                        convertToLocalDateTime(
                          getApprovedUser(scope.row).approved_at
                        ) | globalDateTimeFormat
                      }}</span
                    >
                  </div>
                  <div v-else>
                    <ul>
                      <li
                        v-for="approver in getApprovedUser(scope.row)"
                        :key="approver._id"
                        class="list-style"
                      >
                        <div
                          v-if="approver.approved_by && approver.approved_at"
                        >
                          <i class="el-icon-user-solid icon-style"></i>
                          Approved by:<span class="approver-text">{{
                            " " + approver.approved_by + ","
                          }}</span
                          ><br />
                          <i class="el-icon-time icon-style"></i>
                          Approved at:<span class="approver-text">{{
                            (" " + convertToLocalDateTime(approver.approved_at))
                              | globalDateTimeFormat
                          }}</span>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div slot="reference">
                    <i class="el-icon-success"></i>
                    <span class="d-inline-block pl-10">
                      {{
                        scope.row.approval_status == "APPROVED"
                          ? "Approved"
                          : ""
                      }}
                    </span>
                    <el-tooltip
                      trigger="hover"
                      effect="dark"
                      content="Revoke Approval"
                      placement="right"
                      v-if="
                        scope.row.allow_revoke_approval &&
                        (scope.row.allow_revoke_for_approved || scope.row.allow_revoke_for_both) &&
                        scope.row.approval_status == 'APPROVED'
                      "
                    >
                      <el-link
                        type="warning"
                        @click="showRevokeApprovalConfirm(scope.row)"
                        :underline="false"
                      >
                        <i class="fa fa-level-up"></i>
                      </el-link>
                    </el-tooltip>
                  </div>
                </el-popover>
              </div>
              <div
                class="error"
                v-else-if="scope.row.approval_status == 'REJECTED'"
              >
                <el-popover
                  placement="top-start"
                  title="Rejection details:"
                  width="300"
                  trigger="hover"
                >
                  <div>
                    <span
                      v-if="
                        getRejectedUser(scope.row) &&
                        getRejectedUser(scope.row).rejected_by
                      "
                      >Rejected by: {{ getRejectedUser(scope.row).rejected_by }}
                    </span>
                    <br />
                    <span
                      v-if="
                        getRejectedUser(scope.row) &&
                        getRejectedUser(scope.row).rejected_at
                      "
                      >Rejected on:
                      {{
                        convertToLocalDateTime(
                          getRejectedUser(scope.row).rejected_at
                        ) | globalDateTimeFormat
                      }}</span
                    >
                    <br />
                    <span
                      v-if="
                        getRejectedUser(scope.row) &&
                        getRejectedUser(scope.row).rejected_reason
                      "
                      style="word-break: break-word"
                    >
                      Reason:
                      {{ getRejectedUser(scope.row).rejected_reason }}
                    </span>
                  </div>
                  <div slot="reference" class="expired-div">
                    <i class="el-icon-error"></i>
                    <span class="d-inline-block pl-10">
                      {{
                        scope.row.approval_status == "REJECTED"
                          ? "Rejected"
                          : ""
                      }}
                      <el-tooltip
                        trigger="hover"
                        effect="dark"
                        content="Revoke Approval"
                        placement="right"
                        v-if="
                          scope.row.allow_revoke_approval &&
                          (scope.row.allow_revoke_for_rejected || scope.row.allow_revoke_for_both) &&
                          scope.row.approval_status == 'REJECTED'
                        "
                      >
                        <el-link
                          type="warning"
                          @click="showRevokeApprovalConfirm(scope.row)"
                          :underline="false"
                        >
                          <i class="fa fa-level-up"></i>
                        </el-link>
                      </el-tooltip>
                    </span>
                  </div>
                </el-popover>
              </div>
              <div
                :class="
                  getReviewerData(scope.row) &&
                  getReviewerData(scope.row).status == 'REJECTED'
                    ? 'error'
                    : 'success'
                "
                v-else-if="checkReviewer(scope.row)"
              >
                <el-popover
                  placement="top-start"
                  :title="getReviewerData(scope.row).title"
                  width="300"
                  trigger="hover"
                >
                  <div>
                    <span v-if="getReviewerData(scope.row).label1"
                      >{{ getReviewerData(scope.row).label1 }}
                    </span>
                    <br />
                    <span v-if="getReviewerData(scope.row).date"
                      >On:
                      {{
                        getReviewerData(scope.row).date | globalDateTimeFormat
                      }}</span
                    >
                    <br />
                    <span
                      v-if="getReviewerData(scope.row).reason"
                      style="word-break: break-word"
                    >
                      Reason:
                      {{ getReviewerData(scope.row).reason }}
                    </span>
                  </div>
                  <div slot="reference">
                    <i
                      :class="
                        getReviewerData(scope.row).status == 'REJECTED'
                          ? 'el-icon-error'
                          : 'el-icon-success'
                      "
                    ></i>
                    <span class="d-inline-block" style="word-break: break-word">
                      {{
                        getReviewerData(scope.row).status +
                        " by " +
                        getReviewerData(scope.row).user_name
                      }}
                    </span>
                  </div>
                </el-popover>
              </div>
              <div class="warning d-flex" v-else>
                <!-- <i class="el-icon-time"></i> -->
                <span class="d-inline-block pl-10">{{
                  scope.row.approval_status == "HOLD"
                    ? approvalHoldName
                    : "Pending"
                }}</span>
                <formbuilderLogs
                  class="primary"
                  :currentFormbuilderData="scope.row"
                  :allEntitiesData="allEntitiesData"
                  :allCompanyUserTypesData="allCompanyUserTypesData"
                  v-on:reload-table="fetchAllEmployee"
                ></formbuilderLogs>
              </div>
            </template>
          </el-table-column>

          <template v-if="allFields.length > 0 && haveOneFormbuilder">
            <el-table-column
              class="tableView"
              v-for="(field, index) of allFields
                .filter(
                  (e) =>
                    e.input_type !== 'DATA_TABLE' &&
                    e.input_type !== 'ENTITY_TABLE'
                )
                .filter((e) => contentFields.indexOf(e.input_type) === -1)"
              :key="index"
              :label="getTruncatedLabel(field.label)"
              :prop="field.data_key"
              min-width="180"
            >
              <template slot-scope="scope">
                <div v-if="isValueDate(getFormbuilderFieldValue(field.data_key, scope.row))">{{ getFormattedDate(getFormbuilderFieldValue(field.data_key, scope.row)) }}</div>
                <div v-else>{{ getFormbuilderFieldValue(field.data_key, scope.row) }}</div>
              </template>
            </el-table-column>
          </template>

          <el-table-column label="Sent Status" min-width="150">
            <template slot-scope="scope">
              <div>
                <span
                  v-if="scope.row.sent_at"
                  class="d-block yale-blue sm-80 line-height-1"
                  >Sent On</span
                >
                <span class="black-coral sm-80" v-if="scope.row.sent_at">
                  {{ scope.row.sent_at | moment("MM-DD-YYYY HH:mm") }}
                </span>

                <span
                  v-if="!scope.row.sent_at"
                  class="d-block yale-blue sm-80 line-height-1"
                  >Not Send</span
                >
              </div>
            </template>
          </el-table-column>

          <el-table-column label="Completion Status" width="170">
            <template slot-scope="scope">
              <div
                class="warning"
                v-if="
                  scope.row.formbuilder_data_status == 'PENDING' ||
                  scope.row.formbuilder_data_status == 'SENT'
                "
              >
                <i class="el-icon-refresh"></i>
                <span class="d-inline-block pl-10">
                  {{
                    scope.row.formbuilder_data_status == "PENDING" ||
                    scope.row.formbuilder_data_status == "SENT"
                      ? "Pending"
                      : ""
                  }}
                </span>
              </div>

              <div
                class="success"
                v-else-if="scope.row.formbuilder_data_status == 'COMPLETED'"
              >
                <i class="el-icon-success"></i>
                <span class="d-inline-block pl-10">
                  {{
                    scope.row.formbuilder_data_status == "COMPLETED"
                      ? "Completed"
                      : ""
                  }}
                </span>
              </div>

              <div
                class="expired-div"
                v-else-if="scope.row.formbuilder_data_status == 'EXPIRED'"
              >
                <i class="el-icon-error"></i>
                <span class="d-inline-block pl-10">
                  {{
                    scope.row.formbuilder_data_status == "EXPIRED"
                      ? "Expired"
                      : ""
                  }}
                </span>
              </div>

              <div v-else>Pending</div>
            </template>
          </el-table-column>
          <el-table-column prop="action" min-width="150px" fixed="right" label="Actions">
            <template slot-scope="scope">
              <el-dropdown>
                <span class="el-dropdown-link">
                  Actions
                  <i class="el-icon-caret-bottom el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <a
                    @click="onHold(scope.row)"
                    v-if="
                      checkIsApproverUser(scope.row, false) &&
                      scope.row.approval_status == 'PENDING'
                    "
                  >
                    <el-dropdown-item
                      icon="el-icon-video-pause"
                      command="view"
                      >{{
                        approvalHoldName ? approvalHoldName : "HOLD"
                      }}</el-dropdown-item
                    >
                  </a>
                  <a
                    @click="onApprove(scope.row)"
                    v-if="checkIsApproverUser(scope.row, false)"
                  >
                    <el-dropdown-item icon="el-icon-finished" command="approve"
                      >Approve</el-dropdown-item
                    >
                  </a>
                  <a
                    @click="showRejectConfirm(scope.row)"
                    v-if="checkIsApproverUser(scope.row, false)"
                  >
                    <el-dropdown-item
                      icon="el-icon-circle-close"
                      command="reject"
                      >Reject</el-dropdown-item
                    >
                  </a>
                  <a
                    @click="viewFormbuilderData(scope.row)"
                    style="border: none"
                  >
                    <el-dropdown-item icon="el-icon-view" command="view"
                      >View</el-dropdown-item
                    >
                  </a>
                  <a
                    @click="editWorkUserData(scope.row)"
                    style="border: none"
                    v-if="checkIsApproverUser(scope.row, true)"
                  >
                    <el-dropdown-item icon="el-icon-edit-outline" command="edit"
                      >Edit</el-dropdown-item
                    >
                  </a>
                  <!-- <a @click="onDelete(scope.row)" style="border: none">
                    <el-dropdown-item icon="el-icon-delete" command="delete">Delete</el-dropdown-item>
                  </a> -->
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <data-tables-server
          :data="data"
          :total="total"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          :pagination-props="paginationProps"
          @query-change="loadData"
          v-loading="loading"
          v-else-if="getIsMobile"
        >
          <el-table-column type="expand">
            <template slot-scope="scope">
              <div class="expand-column-item" v-if="hasIntervals">
                <div class="expand-column-item-label">Submitted For</div>
                <div class="expand-column-item-content">
                  {{
                    scope.row.time_interval
                      | moment(fequencyDateMap[intervalType])
                  }}
                </div>
              </div>
              <div class="expand-column-item">
                <div class="expand-column-item-label">Sent Status</div>
                <div class="expand-column-item-content">
                  {{ scope.row.sent_at | moment("MM-DD-YYYY HH:mm") }}
                </div>
              </div>
              <div class="expand-column-item">
                <div class="expand-column-item-label">Completion Status</div>
                <div class="expand-column-item-content">
                  <div class="warning">
                    <i
                      class="el-icon-refresh"
                      v-if="
                        scope.row.formbuilder_data_status == 'PENDING' ||
                        scope.row.formbuilder_data_status == 'SENT'
                      "
                    ></i>
                    <span class="d-inline-block pl-10">
                      {{
                        scope.row.formbuilder_data_status == "PENDING" ||
                        scope.row.formbuilder_data_status == "SENT"
                          ? "Pending"
                          : ""
                      }}
                    </span>
                  </div>

                  <div class="success">
                    <i
                      class="el-icon-success"
                      v-if="scope.row.formbuilder_data_status == 'COMPLETED'"
                    ></i>
                    <span class="d-inline-block pl-10">
                      {{
                        scope.row.formbuilder_data_status == "COMPLETED"
                          ? "Completed"
                          : ""
                      }}
                    </span>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column width="50" fixed="left">
            <template>
              <div>
                <img src="@/assets/img/avatar-2.svg" alt="avatar" width="30" />
              </div>
            </template>
          </el-table-column>
          <el-table-column label="User" min-width="300">
            <template slot-scope="scope">
              <div class="d-flex">
                <div class="pl-15">{{ getUserEmail(scope.row) }}</div>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="action" min-width="100px">
            <template slot-scope="scope">
              <el-dropdown>
                <span class="el-dropdown-link">
                  Actions
                  <i class="el-icon-caret-bottom el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <a
                    @click="onApprove(scope.row)"
                    v-if="checkIsApproverUser(scope.row)"
                  >
                    <el-dropdown-item icon="el-icon-finished" command="approve"
                      >Approve</el-dropdown-item
                    >
                  </a>
                  <a
                    @click="showRejectConfirm(scope.row)"
                    v-if="checkIsApproverUser(scope.row)"
                  >
                    <el-dropdown-item
                      icon="el-icon-circle-close"
                      command="reject"
                      >Reject</el-dropdown-item
                    >
                  </a>
                  <a
                    @click="viewFormbuilderData(scope.row)"
                    style="border: none"
                  >
                    <el-dropdown-item icon="el-icon-view" command="view"
                      >View</el-dropdown-item
                    >
                  </a>
                  <a
                    @click="editWorkUserData(scope.row)"
                    style="border: none"
                    v-if="checkIsApproverUser(scope.row)"
                  >
                    <el-dropdown-item icon="el-icon-edit-outline" command="edit"
                      >Edit</el-dropdown-item
                    >
                  </a>
                  <!-- <a @click="onDelete(scope.row)" style="border: none">
                    <el-dropdown-item icon="el-icon-delete" command="delete">Delete</el-dropdown-item>
                  </a> -->
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </data-tables-server>
      </div>
    </div>
    <el-pagination
      v-if="!loading"
      :class="'custom-pagination'"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage"
      :page-sizes="pageSizes"
      :page-size="pageSize"
      :pager-count="5"
      layout="prev, pager, next, jumper, sizes, total"
      :total="total"
      small
    ></el-pagination>
    <dialog-component
      :destroy-on-close="true"
      :containerWidth="getIsMobile ? '100%' : '40%'"
      :containerMaxHeight="getIsMobile ? '100%' : '70%'"
      :visible.sync="reasonForRejectModal"
      title="Reason for reject"
      @before-close="reasonForRejectModalPop"
    >
      <el-input
        type="textarea"
        :rows="2"
        placeholder="Reason for reject"
        v-model="reasonForReject"
        class="mt-1 mb-1"
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="rejectFormbuilder(reasonForRejectData)"
          type="primary"
          :disabled="!reasonForReject.length"
          >Submit</el-button
        >
        <el-button @click="reasonForRejectModal = false">Cancel</el-button>
      </span>
    </dialog-component>
    <dialog-component
      :destroy-on-close="true"
      :visible.sync="showRevokeReasonDialog"
      :containerWidth="getIsMobile ? '100%' : '40%'"
      :containerMaxHeight="getIsMobile ? '100%' : '70%'"
      title="Reason for revoke approval"
      @before-close="closeRevokeDialog"
    >
      <div class="p-4">
        Are you sure to revoke the approval? Please mention your reason below:
        <el-input
          type="textarea"
          :rows="4"
          placeholder="Reason for revoke approval (Optional)"
          v-model="reasonForRevokeApproval"
          class="mt-1 mb-1"
        ></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="revokeApproval(reasonForRevokeApprovalData)"
          type="primary"
          >Revoke</el-button
        >
        <el-button @click="closeRevokeDialog">Cancel</el-button>
      </span>
    </dialog-component>

    <dialog-component
      :destroy-on-close="true"
      :visible.sync="showBulkRejectDialog"
      :containerWidth="getIsMobile ? '100%' : '40%'"
      :containerMaxHeight="getIsMobile ? '100%' : '70%'"
      title="Reason for rejection"
      @before-close="closeBulkRejectDialog"
    >
      <el-input
        type="textarea"
        :rows="2"
        placeholder="Reason for reject"
        v-model="reasonForBulkRejection"
        class="mt-1 mb-1"
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="rejectSelctedFormData()"
          type="primary"
          :disabled="!reasonForBulkRejection.length"
          >Submit & Reject All</el-button
        >
        <el-button @click="closeBulkRejectDialog">Cancel</el-button>
      </span>
    </dialog-component>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import config from "@/config/app";
import FormbuilderHelper from "@/mixins/FormbuilderHelper.js";
import TemplateBuilderHelper from "@/mixins/templateBuilderHelper.js";
// import formBuilderSharingSettings from "../widgets/formBuilderSharingSettings.vue";
import { postAPICall } from "@/helpers/httpHelper";
export default {
  name: "FormbuilderUsersData",
  components: {
    formbuilderLogs: () => import("@/components/widgets/formbuilderLogsWidget"),
    // formBuilderSharingSettings,
  },
  mixins: [FormbuilderHelper, TemplateBuilderHelper],
  data() {
    return {
      haveOneFormbuilder: false,
      allFields: [],
      currentFormbuilderDetails: {},
      templateFields: [],
      templateIds: [],
      contentFields: [
        "HEADING",
        "PARAGRAPH",
        "VIDEO",
        "SINGLE_LINE_CONTENT",
        "HORIZONTAL_LINE",
        "DIVISION",
        "HTML_CONTENT",
        "ACTION_BUTTON",
        "HTML_CONTENT"
      ],
      formbuilder_code: null,
      loading: false,
      editDailogVisible: false,
      selectedOfferLetterTemplate: "",
      total: 0,
      currentPage: 1,
      pageSize: 0,
      pageSizes: [10, 20, 50, 100],
      data: [],
      addDialogVisible: false,
      previewDialogVisible: false,
      selectedOfferLetter: null,
      viewOfferLetterVisible: false,
      documentSelectDialogVisible: false,
      selectedConfigurableDocument: null,
      documentsLoading: false,
      selectedEmployee: null,
      title: "",
      firstTemplateFields: [],
      firstTemplateId: null,
      workflowIconPath: "block-portfolio.svg",
      workFlowPublicURL: "",
      selectedUserId: "",
      hasIntervals: false,
      intervalType: "",
      fequencyDateMap: {
        DAILY: "YYYY-DD-MM",
        WEEKLY: "YYYY-DD-MM",
        MONTHLY: "YYYY-DD-MM",
        YEARLY: "YYYY-DD-MM",
        HOURLY: "YYYY-DD-MM HH:mm",
      },
      formbuilderReciever: "",
      approver: "",
      approvedFormsData: [],
      activeTab: "need_to_be_approved",
      needToApproveOthersCount: 0,
      holdCount: 0,
      needToApproveCount: 0,
      approvedCount: 0,
      rejectedCount: 0,
      reasonForReject: "",
      reasonForRejectModal: false,
      reasonForRejectData: null,
      allEntitiesData: [],
      allCompanyUserTypesData: [],
      showRevokeReasonDialog: false,
      reasonForRevokeApproval: "",
      reasonForRevokeApprovalData: null,
      loadingText: "Fetching data, please wait...",
      approvalHoldName: "HOLD",
      selectedRowsIds: [],
      showBulkRejectDialog: false,
      reasonForBulkRejection: "",
      selectedFilterFormbuilderids: [],
      allFormbuildersDetails: [],
    };
  },
  computed: {
    ...mapGetters("formBuilders", [
      "getFormBuilderAddStatus",
      "getFormBuilder",
      "getFormBuilderRemindersSettings",
      "getFormBuilderUpdateStatus",
      "getFormBuilderPublicURLDetails",
    ]),
    ...mapGetters("formbuilderData", [
      "getFormbuilderUsersData",
      "getFormbuilderUniqueUsersData",
      "getFormbuilderCreateByContactData",
      "getFormbuilderCreateByContactStatus",
      "getFormbuilderCreateByContactErrors",
      "getFormbuilderDataDeleteStatus",
      "getFormbuilderDataDeleteError",
      "getFormbuilderDataUpdateStatus",
      "getFetchUsersApprovalFormbuilderData",
      "getFetchUsersApprovalFormbuilderCount",
      "getFormbuilderDataUpdateError",
    ]),
    ...mapGetters("templatesData", ["getTemplateFieldsData"]),
    ...mapGetters("companyEntities", ["getSingleCompanyEntity"]),
    ...mapGetters("contacts", ["getAllContacts"]),
    ...mapGetters("navigationOpen", ["getIsMobile"]),
    ...mapGetters("auth", [
      "getAuthenticatedUser",
      "getActiveWorkspace",
      "getUserType",
      "getUserTypeList",
    ]),
    ...mapGetters("company", ["getCompanyDetails"]),
    isCompanyOwner() {
      return this.getFormBuilder.form_builders_owner == "COMPANY";
    },
    paginationProps() {
      return {
        pageSizes: this.pageSizes || [10, 20, 50, 100]
      };
    },
    logoUploadUrl() {
      return config.S3_BUCKET_URL;
    },
    getUserEmail() {
      return (formbuilderData) => {
        if (formbuilderData.contact) {
          return formbuilderData.contact && formbuilderData.contact.email
            ? formbuilderData.contact.email
            : "";
        }
        return "";
      };
    },
    getUserName() {
      return (formbuilderData) => {
        if (formbuilderData.contact) {
          return formbuilderData.contact &&
            formbuilderData.contact.first_name &&
            formbuilderData.contact.last_name
            ? formbuilderData.contact.first_name +
                " " +
                formbuilderData.contact.last_name
            : "";
        }
        return "";
      };
    },
    getContacts() {
      return this.getAllContacts && this.getAllContacts.data
        ? this.getAllContacts.data
        : [];
    },
    isApprovedForm() {
      return true;
    },
  },
  async mounted() {
    await this.$store.commit(
          "entitiesData/setApplyFormbuilderFilters",
          null,
          {
            root: true,
          }
        );
    let limit = (this.pageSizes && this.pageSizes[0]) || 10;
    this.pageSize = limit;
    [this.allCompanyUserTypesData, this.allEntitiesData] = await Promise.all([
      this.fetchCompanyUsersTypes(),
      this.fetchAllEntities(),
    ]);
    await this.getNecessaryInfo();
    await this.$store.commit("formBuilders/setFormBuilderPrevRouter", null, {
      root: true,
    });

  },

  methods: {
    getTruncatedLabel(label) {
      return label.length > 50 ? label.slice(0, 50) + '...' : label;
    },
    handleSelectionChange(checkedRows) {
      this.selectedRowsIds = checkedRows;
    },
    async approveAllChecked() {
      this.$confirm(
        "Are you sure to approve the selected form responses?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      ).then(() => {
        this.approveSelectedFormData();
      });
    },
    //Bulk Approve form responses
    async approveSelectedFormData() {
      this.loading = true;
      this.loadingText = "Approving the form responses, please wait...";
      let params = [];
      this.selectedRowsIds.forEach((item, i) => {
        if (
          item &&
          item._id &&
          (item.approval_status == "PENDING" || item.approval_status == "HOLD")
        ) {
          let currentuserIndex = this.getCurrentApprover(item);
          if (currentuserIndex > -1) {
            let approvalData = this.getApprovalParams(item, currentuserIndex);
            params.push({
              id: item._id,
              approval_data: approvalData,
            });
          }
        } else {
          i = i + 1;
          if (i == this.selectedRowsIds.length) {
            this.$message({
              message: `${i} form(s) are already ${item.approval_status}`,
              type: "warning",
            });
          }
          this.loading = false;
        }
      });
      if (params.length) {
        const response = await postAPICall(
          "POST",
          "/formbuilder-data/bulk-approval-actions",
          params
        );
        if (response.success) {
          this.$notify.success({
            title: "Success",
            message: "Form responses approved successfully",
          });
          this.fetchAllEmployee();
        }
      }
      this.loading = false;
      this.loadingText = "Fetching data, please wait...";
    },
    showBulkRejectConfirm() {
      this.showBulkRejectDialog = true;
      this.showBulkRejectReason = "";
    },
    closeBulkRejectDialog() {
      this.showBulkRejectDialog = false;
      this.showBulkRejectReason = "";
    },
    //Bulk reject form responses
    async rejectSelctedFormData() {
      this.closeBulkRejectDialog();
      this.loading = true;
      this.loadingText = "Rejecting the form responses, please wait...";
      let params = [];
      this.selectedRowsIds.forEach((item, i) => {
        if (
          item &&
          item._id &&
          (item.approval_status == "PENDING" || item.approval_status == "HOLD")
        ) {
          let currentuserIndex = this.getCurrentApprover(item);
          if (currentuserIndex > -1) {
            let approvalData = this.getRejectParams(
              item,
              currentuserIndex,
              this.reasonForBulkRejection
            );
            params.push({
              id: item._id,
              approval_data: approvalData,
            });
          }
        } else {
          i = i + 1;
          if (i == this.selectedRowsIds.length) {
            this.$message({
              message: `${i} form(s) are already ${item.approval_status}`,
              type: "warning",
            });
          }
          this.loading = false;
        }
      });
      if (params.length) {
        const response = await postAPICall(
          "POST",
          "/formbuilder-data/bulk-approval-actions",
          params
        );
        if (response.success) {
          this.$notify.success({
            title: "Success",
            message: "Form responses rejected successfully",
          });
          this.fetchAllEmployee();
        }
      }
      this.loading = false;
      this.loadingText = "Fetching data, please wait...";
    },
    async holdAllChecked() {
      this.$confirm(
        "Are you sure to hold the selected form responses?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      ).then(() => {
        this.holdSelctedFormData();
      });
    },
    async holdSelctedFormData() {
      this.loading = true;
      this.loadingText = "Holding the form responses, please wait...";
      let params = [];
      let approvalData = {
        approval_status: "HOLD",
      };
      this.selectedRowsIds.forEach((item, i) => {
        if (item && item._id && item.approval_status == "PENDING") {
          let currentuserIndex = this.getCurrentApprover(item);
          if (currentuserIndex > -1) {
            params.push({
              id: item._id,
              approval_data: approvalData,
            });
          }
        } else {
          i = i + 1;
          if (i == this.selectedRowsIds.length) {
            this.$message({
              message: `${i} form(s) are already ${item.approval_status}`,
              type: "warning",
            });
          }
          this.loading = false;
        }
      });
      if (params.length) {
        const response = await postAPICall(
          "POST",
          "/formbuilder-data/bulk-approval-actions",
          params
        );
        if (response.success) {
          this.$notify.success({
            title: "Success",
            message: `Form responses ${this.approvalHoldName} successfully`,
          });
          this.fetchAllEmployee();
        }
      }
      this.loading = false;
      this.loadingText = "Fetching data, please wait...";
    },
    showRevokeApprovalConfirm(formbuilderData) {
      this.reasonForRevokeApprovalData = null;
      this.reasonForRevokeApproval = "";
      this.showRevokeReasonDialog = true;
      this.reasonForRevokeApprovalData = { ...formbuilderData };
    },
    closeRevokeDialog() {
      this.showRevokeReasonDialog = false;
    },
    async revokeApproval(data) {
      try {
        this.showRevokeReasonDialog = false;
        this.loading = true;
        this.loadingText = "Revoking approval, please wait...";
        if (
          data?.allow_revoke_approval &&
          ["APPROVED", "REJECTED"].includes(data.approval_status)
        ) {
          const response = await postAPICall(
            "POST",
            "/formbuilder-data/revoke-approval",
            {
              formbuilder_details_id: data.formbuilders_details_id,
              formbuilder_data_id: data._id,
              revoke_reason: this.reasonForRevokeApproval,
              revoked_by:
                this.getAuthenticatedUser?.first_name +
                " " +
                this.getAuthenticatedUser?.last_name +
                "#" +
                this.getAuthenticatedUser?.email,
            }
          );
          if (response) {
            this.$notify.success({
              title: "Success",
              message: "Approval revoked successfully",
            });
            this.fetchAllEmployee();
            this.loading = false;
          }
          this.loading = false;
          this.loadingText = "";
          this.reasonForRevokeApprovalData = null;
          this.reasonForRevokeApproval = "";
        }
      } catch (err) {
        console.log("error while revoking approval", err);
      }
    },
    async onHold(row) {
      this.$confirm("Are you sure to hold the response?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      }).then(() => {
        this.holdFormbuilder(row);
      });
    },
    reasonForRejectModalPop() {
      this.reasonForRejectModal = false;
    },
    async holdFormbuilder(formbuilderData) {
      this.loading = true;
      let currentuserIndex = this.getCurrentApprover(formbuilderData);
      if (currentuserIndex > -1) {
        await this.$store.dispatch("formbuilderData/updateFormbuilderData", {
          approval_status: "HOLD",
          id: formbuilderData._id,
        });
        if (this.getFormbuilderDataUpdateStatus) {
          this.$message({
            message: `Form state updated to ${this.approvalHoldName} successfully!`,
            type: "success",
          });
          this.fetchAllEmployee();
        } else {
          this.$notify.warning({
            title: "Warning",
            message:
              this.getFormbuilderDataUpdateError.message ||
              "Error while Form state updated to hold",
          });
          this.fetchAllEmployee();
        }
      } else {
        this.$notify.warning({
          title: "Warning",
          message: "You are not approver",
        });
      }
      this.loading = false;
    },
    convertToLocalDateTime(dateTime) {
      const date = new Date(dateTime);
      return date.toLocaleString();
    },
    isAnonymousForm(formbuilderData) {
      return (
        formbuilderData?.formbuilders_details_id?.form_builders_owner ===
        "ANONYMOUS"
      );
    },
    getApprovedUser(formbuilderData) {
      // In priority based approvals, only main approver details should be displayed
      if (formbuilderData?.approval_users && formbuilderData?.priority_based) {
        return formbuilderData?.approval_users.find(
          (e) =>
            (!formbuilderData.priority_based && e.approved_status) ||
            (formbuilderData.priority_based &&
              e.approved_status &&
              e.final_approver)
        );
      } else {
        // In non-priority based(all users need to approve) approvals, all approvers details should be displayed, so returning all the approvers
        return formbuilderData?.approval_users;
      }
    },
    getRejectedUser(formbuilderData) {
      if (formbuilderData?.approval_users) {
        return formbuilderData?.approval_users.find(
          (e) =>
            (!formbuilderData.priority_based && e.rejected_status) ||
            (formbuilderData.priority_based &&
              e.rejected_status &&
              e.final_approver)
        );
      }
      return null;
    },
    checkIsApproverUser(formbuilderData, isEdit) {
      if (
        formbuilderData?.approval_users &&
        formbuilderData?.approval_status != "APPROVED" &&
        formbuilderData?.approval_status != "REJECTED" &&
        !isEdit
      ) {
        let currentuserIndex = this.getCurrentApprover(formbuilderData);
        if (
          currentuserIndex > -1 &&
          !formbuilderData.approval_users[currentuserIndex].approved_status &&
          !formbuilderData.approval_users[currentuserIndex].rejected_status
        ) {
          return formbuilderData.formbuilder_data_status == "COMPLETED";
        }
        //return false;
      }
      if (
        isEdit &&
        (formbuilderData?.approval_status == "APPROVED" ||
          formbuilderData?.approval_status == "REJECTED")
      ) {
        if (
          formbuilderData?.formbuilders_details_id
            ?.approval_receiver_permissions
        ) {
          let permissions =
            formbuilderData?.formbuilders_details_id
              ?.approval_receiver_permissions;
          if (permissions?.edit == true) {
            return true;
          }
        }
      }
      return false;
    },
    async onApprove(row) {
      if (row?.approval_redirection) {
        return this.redirect(row.approval_redirection, row);
      }
      this.$confirm("Are you sure to approve the response?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      }).then(() => {
        this.approveFormbuilder(row);
      });
    },
   async redirect(entityId, row) {
      if (entityId) {
        if(row?.formbuilders_details_id?.approval_redirection_filter){
          let data = {};
          let entity_data_ids = row.formbuilder_steps_data.filter(e => e.entity_data_id).flatMap(e => e.entity_data_id);
          let templates_data_ids = row.formbuilder_steps_data.filter(e => e.template_data_id).flatMap(e => e.template_data_id);
          if(entity_data_ids.length){
            let response = await postAPICall("GET", "/templates-data", {
              entity_data_ids: entity_data_ids
            });
            // let obj = {};
            (response?.data || []).forEach(d => {
              if(data[d.entity_id]){
                data = {
                  ...data,
                  ...{
                    [d.template_id]: d.template_data
                  }
                }
              }else{
                data[d.entity_id] = {

                  [d.template_id]: d.template_data
                };
              }
            });
           
          }

          if(templates_data_ids.length){
            let response = await postAPICall("GET", "/templates-data", {
              template_data_ids: templates_data_ids
            });
            console.log("response", response);
          }
          let newFilters = (row.formbuilders_details_id.approval_redirection_filter?.filters || []).map(filter => {
            if(filter?.value_field && filter.value_field.includes("#")){
              let [e, t, f] = filter.value_field.split("#");
              if(data?.[e]?.[t]?.[f]){
                filter.value = data[e][t][f];
              }
            }
            return filter;
          });
          console.log("newFilters", newFilters);
          await this.$store.commit(
          "entitiesData/setApplyFormbuilderFilters",
          newFilters,
          {
            root: true,
          }
        );
          console.log("==", data);
            this.$router.push({
          path: `/entity/${entityId}?key=${Math.floor(
            Math.random() * 100000
          )}&viewType=HTML_CONTENT`,
          query: {
            fromApprovalForms: true,
          },
        });

        }
        else{
            this.$router.push({
          path: `/entity/${entityId}?key=${Math.floor(
            Math.random() * 100000
          )}&viewType=HTML_CONTENT`,
          query: {
            fromApprovalForms: true,
          },
        });
        }
      
        
      }
    },
    async onReject(row) {
      this.$confirm("Are you sure to reject the response?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      }).then(() => {
        this.rejectFormbuilder(row);
      });
    },
    async approveFormbuilder(formbuilderData) {
      this.loading = true;
      this.loadingText = "Approving the form, please wait...";
      let currentuserIndex = this.getCurrentApprover(formbuilderData);
      if (currentuserIndex > -1) {
        let params = this.getApprovalParams(formbuilderData, currentuserIndex);
        await this.$store.dispatch(
          "formbuilderData/updateFormbuilderData",
          params
        );
        if (this.getFormbuilderDataUpdateStatus) {
          this.$message({
            message: "Approved successfully!",
            type: "success",
          });
          this.fetchAllEmployee();
        } else {
          this.$notify.warning({
            title: "Warning",
            message:
              this.getFormbuilderDataUpdateError.message ||
              "Error while approving",
          });
          this.fetchAllEmployee();
        }
      } else {
        this.$notify.warning({
          title: "Warning",
          message: "You are not approver",
        });
      }
      this.loadingText = "";
      this.loading = false;
    },
    showRejectConfirm(formbuilderData) {
      this.reasonForRejectData = null;
      this.reasonForReject = "";
      this.reasonForRejectModal = true;
      this.reasonForRejectData = { ...formbuilderData };
    },
    async rejectFormbuilder(formbuilderData) {
      this.loading = true;
      this.loadingText = "Rejecting the form, please wait...";
      let currentuserIndex = this.getCurrentApprover(formbuilderData);
      if (currentuserIndex > -1) {
        let params = this.getRejectParams(
          formbuilderData,
          currentuserIndex,
          this.reasonForReject
        );
        await this.$store.dispatch(
          "formbuilderData/updateFormbuilderData",
          params
        );
        if (this.getFormbuilderDataUpdateStatus) {
          this.$message({
            message: "Rejected successfully!",
            type: "success",
          });
          this.reasonForRejectData = null;
          this.reasonForReject = "";
          this.reasonForRejectModal = false;
          this.fetchAllEmployee();
        } else {
          this.$notify.warning({
            title: "Warning",
            message:
              this.getFormbuilderDataUpdateError.message ||
              "Error while approving",
          });
          this.fetchAllEmployee();
        }
      } else {
        this.$notify.warning({
          title: "Warning",
          message: "You are not approver",
        });
      }
      this.loadingText = "";
      this.loading = false;
    },
    handleClick(tab, event) {
      console.log("clicked tab", tab, event);
      this.fetchAllEmployee();
    },
    printScope(r) {
      console.log(r);
    },
    async getNecessaryInfo() {
      this.loading = true;
      await this.fetchAllEmployee();
      this.approvalHoldName = this.getCompanyDetails
        ?.formbuilder_approval_hold_name
        ? this.getCompanyDetails.formbuilder_approval_hold_name
        : "HOLD";
      this.loading = false;
    },

    onEdit(row) {
      this.selectedOfferLetterTemplate = row;
      this.editDailogVisible = true;
    },
    async onView(row) {
      this.selectedOfferLetterTemplate = row;
      this.previewDialogVisible = true;
    },
    async onDelete(row) {
      this.$confirm("Are you sure to delete the response?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      }).then(() => {
        this.deleteTemplate(row);
      });
    },
    async deleteTemplate(row) {
      //deleteFormbuilderData
      await this.$store.dispatch(
        "formbuilderData/deleteFormbuilderData",
        row._id
      );
      if (this.getFormbuilderDataDeleteStatus) {
        this.$message({
          message: "Response deleted successfully!",
          type: "success",
        });
        this.fetchAllEmployee();
      } else {
        this.$notify.error({
          title: "Error",
          message: "Something went wrong. Can't delete.",
        });
      }
    },

    async updateUserQuery(value) {
      this.$router.replace({
        name: this.$route.name,
        params: this.$route.params,
        query: { ...this.$route.query, user_id: value },
      });

      await this.getNecessaryInfo();
    },
    async fetchAllEmployee() {
      this.loading = true;
      this.data = [];
      let params = {
        page: this.currentPage,
        limit: this.pageSize,
        include_template_details: false,
        include_user_details: true,
        include_formbuilder_details: true,
      };
      if (this.activeTab == "hold") {
        params.include_hold = true;
        params.include_need_to_be_approved = true;
      } else if (this.activeTab == "approved") {
        params.include_approval_status = "APPROVED";
      } else if (this.activeTab == "rejected") {
        params.include_approval_status = "REJECTED";
      } else if (this.activeTab == "need_to_be_approved") {
        params.include_need_to_be_approved = true;
      } else {
        params.include_need_to_be_approved = false;
      }
      if (this.selectedFilterFormbuilderids?.length) {
        params.selected_formbuilders = this.selectedFilterFormbuilderids;
      }
      await Promise.all([
        this.$store.dispatch(
          "formbuilderData/fetchUsersApprovalFormbuilderData",
          params
        ),
        this.$store.dispatch(
          "formbuilderData/fetchUsersApprovalFormbuilderCount",
          {}
        ),
      ]);
      this.currentPage =
        parseInt(this.getFetchUsersApprovalFormbuilderData.page) || 1;
      this.total =
        parseInt(this.getFetchUsersApprovalFormbuilderData.data.length) || 0;

      if (
        this.getFetchUsersApprovalFormbuilderData.data &&
        this.getFetchUsersApprovalFormbuilderData.data.length
      ) {
        this.data = this.getFetchUsersApprovalFormbuilderData.data;
        this.haveOneFormbuilder = this.data.every(
          item => item?.formbuilders_details_id?._id === this.data[0]?.formbuilders_details_id?._id
        );
        this.getFormbuilderUserData(this.data);
        this.approver =
          this.getFetchUsersApprovalFormbuilderData.approver || "";
      } else {
        this.approver = "";
        this.data = [];
      }
      if (this.getFetchUsersApprovalFormbuilderCount.data) {
        this.needToApproveCount =
          this.getFetchUsersApprovalFormbuilderCount.data.pending;
        this.approvedCount =
          this.getFetchUsersApprovalFormbuilderCount.data.approved;
        this.rejectedCount =
          this.getFetchUsersApprovalFormbuilderCount.data.rejected;
        this.needToApproveOthersCount =
          this.getFetchUsersApprovalFormbuilderCount.data.pendingByOthers;
        this.holdCount =
          this.getFetchUsersApprovalFormbuilderCount.data.holdCount;
      }
      if (this.activeTab == "hold") {
        this.total = this.holdCount;
      } else if (this.activeTab == "approved") {
        this.total = this.approvedCount;
      } else if (this.activeTab == "rejected") {
        this.total = this.rejectedCount;
      } else if (this.activeTab == "need_to_be_approved") {
        this.total = this.needToApproveCount;
      } else if (this.activeTab == "waiting_for_others") {
        this.total = this.needToApproveOthersCount;
      }
      this.allFormbuildersDetails = [
        ...new Map(
          this.data.map((item) => [
            JSON.stringify(item?.formbuilders_details_id),
            item?.formbuilders_details_id,
          ])
        ).values(),
      ];
      if (this.haveOneFormbuilder) {
        await this.$store.dispatch("formBuilders/fetchFormBuilderByCode", {
          code: this.allFormbuildersDetails[0].code,
          include_template_details: true,
          include_entity_details: true,
          include_documents_details: true
        });
        this.currentFormbuilderDetails = this.getFormBuilder;
        let entities = this.currentFormbuilderDetails.steps.filter(
          step => step.type == "ENTITY"
        );
        let templates = this.currentFormbuilderDetails.steps
          .filter(
            step => step.type == "TEMPLATE" && !step?.settings?.is_repeatable
          )
          .map(step => step.template);
        entities.forEach(entity => {
          let allowedTemplates = entity?.settings?.selectedTemplates
            ? entity.settings.selectedTemplates
            : [];
          if (entity?.entity?.templates) {
            entity.entity.templates.forEach(template => {
              if (
                template?.template_id?._id &&
                !template.is_repeatable &&
                allowedTemplates.indexOf(template?.template_id?._id) != -1
              ) {
                let fields = this.getTemplateFields(
                  template.template_id,
                  "ENTITY",
                  entity.entity
                );
                this.templateFields.push({
                  fields: fields,
                  label: entity.entity.name + "-" + template.template_id.name,
                  key: template._id,
                  entity_id: entity._id
                });
                this.allFields = this.allFields.concat(fields);
              }
            });
          }
        });
        this.templateIds = templates.map(template => template._id);
        this.templateFields = [
          ...this.templateFields,
          ...templates.map(template => {
            template.fields = this.getTemplateFields(template, "TEMPLATE");
            this.allFields = this.allFields.concat(template.fields);
            template.label = template.name;
            template.key = template._id;
            return template;
          })
        ];
      }
      this.loading = false;
    },
    getTemplateFields(data, type, entity = {}) {
      let fields = [];
      data.sections.forEach(e => {
        fields = [...fields, ...e.fields];
      });
      fields = fields.map(e => {
        e.template_id = data._id;
        e.template_title = data.name;
        e.checked = true;
        e.table_display = true;
        e.type = type;
        if (type == "ENTITY" && entity?._id) {
          e.label = entity.name + " - " + data.name + " - " + e.label;
          e.data_key = entity._id + "#" + data._id + "#" + e.key;
          e.key = entity._id + "#" + data._id + "#" + e.key;
          e.entity_type_id = entity._id;
        } else {
          e.data_key = data._id + "#" + e.key;
          e.key = data._id + "#" + e.key;
          e.label = data.name + " - " + e.label;
        }
        return e;
      });
      return fields;
    },
    async handleSizeChange(val) {
      this.loading = true;
      this.pageSize = val;
      this.currentPage = 1;
      await this.fetchAllEmployee();
      this.loading = false;
    },
    async handleCurrentChange(val) {
      this.loading = true;
      this.currentPage = val;
      await this.fetchAllEmployee();
      this.loading = false;
    },
    backToWorkFlows() {
      this.$router.push({ path: "/formBuilders" });
    },
    parseFirstTemplateData(data) {
      let modifiedData = data.map((e) => {
        let dataObject = {
          _id: e._id,
          name: e.name,
          code: e.code,
          formbuilder_data_status: e.formbuilder_data_status,
          workflow_data_sender_status: e.workflow_data_sender_status,
        };

        let firstTemplateData = e.template_data_ids.find(
          (x) => x.template_id._id == this.firstTemplateId
        );

        if (firstTemplateData) {
          let firstTemplateValues =
            firstTemplateData.template_data_id &&
            firstTemplateData.template_data_id.template_data
              ? firstTemplateData.template_data_id.template_data
              : {};
          dataObject.template_data = firstTemplateValues;
        } else {
          dataObject.template_data = {};
        }

        return dataObject;
      });
      return modifiedData;
    },
    async fetchAllConfigurableDocuments() {
      this.documentsLoading = true;
      await this.$store.dispatch(
        "configurableDocuments/fetchConfigurableDocuments",
        {
          get_all: true,
          type: "FORM",
        }
      );
      this.documentsLoading = false;
    },
    copyURL(url) {
      navigator.clipboard.writeText(url);
      this.$message({
        message: "Link copied successfully!",
        type: "success",
      });
    },

    async generateFormbuilderPublicURL() {
      try {
        this.loading = true;
        await this.$store.dispatch("formBuilders/fetchWorkFlowPublicURL", {
          formbuilder_details_id: this.getFormBuilder._id,
        });

        this.workFlowPublicURL = this.getFormBuilderPublicURLDetails.public_url;
        this.false = true;
      } catch (err) {
        console.log("generateFormbuilderPublicURL", err);
      }
    },
    async loadData(data) {
      if (this.data && this.data.length) {
        this.pageSize = data.pageSize;
        this.page = data.page;
        await this.fetchAllEmployee();
      }
    },

    async selectDocuemnt(doc) {
      this.selectedConfigurableDocument = doc;
    },
    async viewFormbuilderData(row) {
      await this.$store.commit(
        "formBuilders/setFormBuilderPrevRouter",
        window.location.href,
        {
          root: true,
        }
      );
      if (row?.formbuilders_details_id?.code) {
        this.$router.push({
          name: "FormbuilderView",
          params: {
            formbuilder_code: row.formbuilders_details_id.code,
            formbuilder_data_id: row._id,
          },
          query: {
            origin: "ckjwdiuv",
          },
        });
      }
    },
    async editWorkUserData(row) {
      await this.$store.commit(
        "formBuilders/setFormBuilderPrevRouter",
        window.location.href,
        {
          root: true,
        }
      );
      if (row?.formbuilders_details_id?.code) {
        this.$router.push({
          name: "FormbuilderEdit",
          params: {
            formbuilder_code: row.formbuilders_details_id.code,
            formbuilder_data_id: row._id,
          },
          query: {
            origin: "ckjwdiuv",
          },
        });
      }
    },
    getFlowName() {
      return this.getFormBuilder?.name;
    },

    getFieldData(templateData, field) {
      if (templateData[field.key]) {
        if (field.input_type == "DATE") {
          return this.$moment.utc(templateData[field.key]).format("MM-DD-YYYY");
        }
        return templateData[field.key];
      }
      return "-";
    },
  },
  watch: {
    "$route.params.workflow_code": async function () {
      await this.getNecessaryInfo();
    },
    async "$route.query.key"() {
      this.getNecessaryInfo();
    },
    async "$route.params.formbuilder_code"() {
      this.getNecessaryInfo();
    },
  },
};
</script>

<style lang="scss" scoped>
.add-buttons {
  border: 1.5px solid #285ed3;
  box-sizing: border-box;
  border-radius: 2px;
  padding: 0.45em 0.65em;
  color: #285ed3;

  &:hover {
    background-color: #285ed3;
    color: #ffffff;
    border-color: #285ed3;
  }
}

#workflow-users-list {
  // width: 90%;
  // display: contents;
  // margin: 0 auto;

  .el-dialog__body {
    padding: 20px 20px;

    .el-card {
      .el-card__body {
        padding: 10px;
      }

      &:not(:last-child) {
        margin-bottom: 20px;
      }
    }
  }
}

.doc {
  min-width: 30px;

  &.selected {
    background: green;
  }
}

.green {
  color: green;
}

.font-17 {
  font-size: 17px;
  cursor: pointer;
}

.documents {
  min-height: 200px;
  max-height: 400px;
  overflow: scroll;
}

.el-table .cell {
  word-break: break-word;
}

.el-table .td {
  word-wrap: break-word;
}

.count-circle {
  display: inline-block;
  width: 24px;
  height: 24px;
  color: #fff;
  /* Text color */
  border-radius: 50%;
  /* Make it circular */
  text-align: center;
  line-height: 24px;
  /* Vertically center the text */
  font-size: 12px;
  /* Adjust font size as needed */
  position: relative;
  /* Add positioning */
  // top: -6px; /* Adjust position as needed */
  left: 4px;
  /* Adjust position as needed */
}
.approver-text {
  color: #3366cc;
}
.list-style {
  margin-top: 10px;
}
.expired-div {
  color: #dc3545;
}
.approval-form {
  margin-top: -25px;
}
.container {
  display: flex;
  align-items: center;
}
.filter-container {
  display: flex;
  align-items: center;
}

.filter-icon-box {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 27px;
  height: 25px;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-right: 6px;
  background-color: #f8f8f8;
}

.filter-icon-box i {
  font-size: 16px;
  color: #333;
}

.custom-pagination {
  padding: 10px;
  margin-left: 27%;
}
</style>
